export const FETCH_ALL_CONSOLIDATED_REQUEST = 'FETCH_ALL_CONSOLIDATED_REQUEST'
export const FETCH_ALL_CONSOLIDATED_SUCCESS = 'FETCH_ALL_CONSOLIDATED_SUCCESS'
export const FETCH_ALL_CONSOLIDATED_FAILED = 'FETCH_ALL_CONSOLIDATED_FAILED'
export const DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST = 'DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_REQUEST'
export const DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS = 'DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_SUCCESS'
export const DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED = 'DOWNLOAD_CONSOLIDATED_ACCOUN_EXCEL_FAILED'
